import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import Icon from 'components/icon/Icon';

import { ITableMobileSort } from 'source/NFR.types';

interface TableMobileSortProps extends ITableMobileSort {
  options: string[];
  selectedOption: string;
  setSortOption: (option: string) => void;
}

const TableMobileSort: React.FC<TableMobileSortProps> = ({
  options,
  selectedOption,
  setSortOption,
  title,
  accordion
}) => {
  return (
    <div>
      <label className="table-mobile-sort--label" htmlFor="sort-button">
        {title}
      </label>
      <Accordion {...accordion} animate={false}>
        {({ Collapse, isOpen, toggle }) => (
          <div className="table-mobile-sort">
            <button id="sort-button" className="table-mobile-sort--dropdown-button" onClick={toggle}>
              {selectedOption}
              <Icon name="arrow-down" />
            </button>
            <Collapse className="table-mobile-sort--collapse">
              <div className="table-mobile-sort--dropdown">
                <h4 className="table-mobile-sort--dropdown-title">{title}</h4>
                <ul className="table-mobile-sort--dropdown-list">
                  {options?.map(option => (
                    <li className="table-mobile-sort--dropdown-item" key={option}>
                      <button
                        className={cn('table-mobile-sort--sort-button', {
                          '-activated': option === selectedOption
                        })}
                        onClick={() => {
                          setSortOption(option);
                          toggle();
                        }}
                      >
                        {option}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </Collapse>
            {isOpen && <button className="table-mobile-sort--overlay" onClick={toggle} />}
          </div>
        )}
      </Accordion>
    </div>
  );
};

TableMobileSort.displayName = 'TableMobileSort';

export default TableMobileSort;
